import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=266b7eeb&scoped=true"
import script from "./goodsManage.vue?vue&type=script&lang=js"
export * from "./goodsManage.vue?vue&type=script&lang=js"
import style0 from "./goodsManage.vue?vue&type=style&index=0&id=266b7eeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266b7eeb",
  null
  
)

export default component.exports